import PageManagementReducer from 'store/page-management/reducers';

export default PageManagementReducer;
